import React from "react";
import PageMeta from "../components/PageMeta";
import PageShell from "../components/PageShell";
import { BookingCTA, Section } from "../components/MarketingPrimitives";
import { signalUseCases, useCaseGroups } from "../content/siteContent";

const UseCases = () => {
  return (
    <PageShell>
      <PageMeta
        title="Use Cases | BestSalesCoach.ai"
        description="See how BestSalesCoach.ai helps revenue teams move from buyer and account signals to opportunity action, stakeholder coverage, MEDDICC execution, and next-best actions."
        canonicalPath="/usecases"
      />
      <Section
        id="usecases-hero"
        eyebrow="Use cases"
        title="Use Cases for Revenue Teams That Need Better Signal-to-Execution"
        description="BestSalesCoach.ai helps CROs, founders, sales managers, and GTM teams improve account prioritisation, pipeline quality, forecast confidence, and execution discipline."
        tone="hero"
      >
        <p className="marketing-body-copy">
          BestSalesCoach.ai turns account signals into qualified opportunity action: who to engage,
          what evidence is missing, what risk exists, and what the team should do next.
        </p>
        <div className="hero-actions">
          <BookingCTA
            eventName="book_demo_click"
            sourcePage="usecases"
            ctaClicked="usecases_book_20_min_demo"
            requestedOffer="BestSalesCoach.ai Platform Demo"
            buyerType="GTM Team"
            urlType="demo"
          />
        </div>
      </Section>

      <Section
        id="signal-to-opportunity-usecases"
        eyebrow="Signal-to-opportunity use cases"
        title="Signal-to-Opportunity Use Cases"
        description="Connect account signal, scoring, context, and recommended action so teams can move faster without losing judgment."
        tone="light"
      >
        <div className="marketing-grid marketing-grid-two">
          {signalUseCases.map((card) => (
            <article key={card.title} className="marketing-card">
              <h3>{card.title}</h3>
              <p>
                <strong>Pain:</strong> {card.pain}
              </p>
              <p>
                <strong>What BestSalesCoach.ai does:</strong> {card.action}
              </p>
              <p>
                <strong>Business outcome:</strong> {card.outcome}
              </p>
            </article>
          ))}
        </div>
      </Section>

      {useCaseGroups.map((group, index) => (
        <Section
          key={group.title}
          id={group.title.toLowerCase().replace(/\s+/g, "-")}
          eyebrow="Audience-specific outcomes"
          title={group.title}
          description="Each use case connects a painful GTM workflow gap to a practical action in the platform and a business outcome leaders can inspect."
          tone={index % 2 === 0 ? "light" : "dark"}
        >
          <div className="marketing-grid marketing-grid-two">
            {group.cards.map((card) => (
              <article key={card.title} className="marketing-card">
                <h3>{card.title}</h3>
                <p>
                  <strong>Pain:</strong> {card.pain}
                </p>
                <p>
                  <strong>What BestSalesCoach.ai does:</strong> {card.action}
                </p>
                <p>
                  <strong>Business outcome:</strong> {card.outcome}
                </p>
              </article>
            ))}
          </div>
        </Section>
      ))}
    </PageShell>
  );
};

export default UseCases;
